export default __webpack_public_path__ + "static/media/amooti.b5eff623.png";